import React from 'react';
import './EnvironmentBadge.css';
import { env } from '../../core/util/env';

function EnvironmentBadge(): React.ReactNode {
  if (env.PROD) {
    return <></>;
  }

  return (
    <div className="env-wrapper">
      <span className={'badge ' + env.MODE.toLowerCase()}>{env.MODE.toUpperCase()}</span>
    </div>
  );
}

export default EnvironmentBadge;
